'use strict';

const _ = require('lodash');
const jQuery = require('jquery');

const Translator = require('./../../../core/translator');
const FormBuilder = require('./../builder');
let ElementClass = require('./../elementClass');

FormBuilder.register('radio', function(config) {
    let self = {};

    self = new ElementClass(config);

    if ((/number|string/).test(typeof config.options)) {
        self.options = [config.options];
    } else if ('object' === typeof config.options) {
        self.options = config.options;
    } else {
        self.options = [];
    }

    if ((/number|string/).test(typeof config.value)) {
        self.checked = [config.value + ''];
    } else if ('object' === typeof config.value) {
        self.checked = config.value;
    } else {
        self.checked = [];
    }

    self.render = function($wrap) {
        if (config.label) {
            $wrap.append(jQuery('<label class="cloud-label">' + config.label + '</label>'));
        }

        _.forEach(self.options, function(option, key) {
            let $div = jQuery('<div/>');
            let $radio = jQuery('<input/>');
            let $label = jQuery('<label/>').append(jQuery('<span class="cloud-control-indicator"></span><span class="cloud-label"></span>'));

            if (config.sub_wrap_class) {
                $div.addClass(config.sub_wrap_class);
            }

            if (config.inline) {
                $div.addClass('form-check-inline');
            }

            if (self.labelClass) {
                $label.addClass(self.labelClass);
            }

            if (self.elementClass) {
                $radio.addClass(self.elementClass);
            }

            $radio.attr('type', 'radio');
            $radio.attr('name', self.name);
            $radio.attr('value', key);

            $label.prepend($radio);
            $label.find('.cloud-label').append(Translator.translate(option));

            if (config.horizontal) {
                $wrap.append($label);
            } else {
                $div.append($label);
                $wrap.append($div);
            }
        });

        $wrap.find('input[type=radio]').each(function() {
            let input = jQuery(this);

            if (-1 !== self.checked.indexOf(input.val())) {
                input.prop('checked', true);
            }
        });

        return;
    };

    self.getData = function() {
        let data = null;

        self.$.find('input').each(function() {
            let input = jQuery(this);

            if (input.is(':checked')) {
                data = input.val();

                return false;
            }
        });

        return data;
    };

    return self;
});
